import styled from "styled-components"

import { RadioButton } from "@minuthq/meatball-ui-react"

import { RadioWrapper } from "src/components/Paradise/sharedStyles"
import { TSetSearchParamsProp } from "src/router/useSearchParams"
import { FilterChip, FilterChipProps } from "src/ui/Filter/FilterChip"
import { spacing } from "src/ui/spacing"

export type TParadiseUserHomeTokensFilters = {
  home_tokens_activated: boolean | null
}

export function ParadiseUserHomeTokensFilters({
  filter,
  setFilter,
}: {
  filter: TParadiseUserHomeTokensFilters
  setFilter: TSetSearchParamsProp<TParadiseUserHomeTokensFilters>
}) {
  const customFilterChips: FilterChipProps[] = [
    {
      label: "Status",
      value:
        filter.home_tokens_activated === true
          ? "Activated only"
          : "Unactivated only",
      active: filter.home_tokens_activated !== null,
      onRemove: () => setFilter("home_tokens_activated", null),
      removeLabel: "Reset",
      children: (
        <FilterContent>
          <RadioWrapper>
            <RadioButton
              name="home_tokens_activated"
              value="true"
              label="Activated"
              selected={filter.home_tokens_activated === true}
              onSelected={() => setFilter("home_tokens_activated", true)}
            />
            <RadioButton
              name="home_tokens_activated"
              value="false"
              label="Unactivated"
              selected={filter.home_tokens_activated === false}
              onSelected={() => setFilter("home_tokens_activated", false)}
            />
          </RadioWrapper>
        </FilterContent>
      ),
    },
  ]

  return (
    <FilterWrapper>
      {customFilterChips.map((filterChip) => (
        <FilterChip key={filterChip.label} {...filterChip} />
      ))}
    </FilterWrapper>
  )
}

const FilterWrapper = styled.div`
  margin-top: ${spacing.M};
`

const FilterContent = styled.div`
  padding: ${spacing.XS};
`
